module.exports = __webpack_public_path__ + "static/click-a39f3d88afc23ea06dbcbd265a5ec5ae.wav";